import Create from './create/CreateVideo';
import Edit from './edit/EditVideo';
import Individual from './individual/Video';
import List from './list/Videos';

export default { Individual, List, Create, Edit };
